interface Props {
  icon?: any;
  title?: string;
  subTitle?: string;
  color?: string;
}

export const NoDataMessage = ({
  icon,
  title,
  subTitle,
  color = '#d1d1d1',
}: Props) => (
  <div
    className="flex flex-col flex-grow items-center justify-center w-full h-full"
    style={{ color: color }}
  >
    {icon ? icon : null}
    <h5 className="text-2xl">{title ? title : 'No data to display'}</h5>
    <span>{subTitle ? subTitle : null}</span>
  </div>
);
